// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fa890282","732":"cae1b1c6","977":"0b4c76ab"}[chunkId] + ".chunk.js";
};